function digitos(n: number): string {
  let out = "";
  for (let i = 0; i < n; i++) out += Math.floor(Math.random() * 10);
  return out;
}

export function gerarCpfFake(): string {
  return `${digitos(3)}.${digitos(3)}.${digitos(3)}-${digitos(2)}`;
}

export function gerarCnpjFake(): string {
  return `${digitos(2)}.${digitos(3)}.${digitos(3)}/0001-${digitos(2)}`;
}

export function gerarCreaFake(uf: string = "SP"): string {
  return `CREA-${uf} ${digitos(6)}`;
}

export function gerarArtFake(): string {
  return `TESTE-${digitos(9)}`;
}

export function gerarPlacaFake(): string {
  const letras = Array.from({ length: 3 }, () =>
    String.fromCharCode(65 + Math.floor(Math.random() * 26)),
  ).join("");
  return `${letras}${digitos(1)}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${digitos(2)}`;
}

export function gerarChassiFake(): string {
  const chars = "ABCDEFGHJKLMNPRSTUVWXYZ0123456789";
  return Array.from(
    { length: 17 },
    () => chars[Math.floor(Math.random() * chars.length)],
  ).join("");
}

export function gerarRenavamFake(): string {
  return digitos(11);
}

export function gerarCartelaFake(): string {
  return digitos(10);
}
